import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

export function useGetPatientSummary(patientId: string) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['patient', patientId, 'summary'],
    queryFn: async () => {
      const response = await api.get('/patients/:patientId/summary', { params: { patientId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.summary
    },
  })
}
